<svg class="svg_icon--cross" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <style>.svg_icon--cross .icon{fill:currentColor;}</style>
  </defs>
  <path class="icon" d="M71.5,63.7c-4.4-6.1-8.9-11-13.2-15.4c-1-1-0.9-2.6,0.1-3.6c4.1-3.7,8.2-7,11.8-9.6c1.6-1.2,2.3-3.4,1.5-5.2
		c-1.2-2.4-4.2-3.1-6.2-1.5c-4.1,3-8.7,6.7-13.4,11c-1.1,1-2.7,1-3.9,0.1c-4.5-3.6-9-6.7-13.6-9.7c-1.5-1-3.5-1-4.9,0.1
		c-2.3,1.9-2,5.2,0.3,6.7c4.3,2.9,8.4,5.7,12.5,8.9c1,0.8,1.1,2.3,0.3,3.2c-4.9,5.2-9.6,10.9-13.4,16.6c-1.1,1.7-0.9,4,0.5,5.4
		c0.9,0.8,1.9,1.2,2.9,1.2c1.4,0,2.6-0.7,3.5-1.9c3.6-5.4,8-10.7,12.7-15.8c0.9-1,2.6-1,3.6,0c4.2,4.1,8.4,8.8,12.5,14.6
		c0.9,1.1,2,1.7,3.3,1.7c1.2,0,2.5-0.5,3.3-1.7C72.7,67.3,72.6,65.1,71.5,63.7z"/>
</svg>